// removed by extract-text-webpack-plugin
module.exports = {"base":"BattleTitle_base--lRO_0","info":"BattleTitle_info--1HoXj"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/BattleTitle/BattleTitle.scss
// module id = 486
// module chunks = 11 12